import React, { useState, useEffect } from 'react';
import "./investmentForm.css";
import { useForm } from "react-hook-form";
import { UpdateInvestment } from '../../common/api/InvestmentAPIHelper';
import { GetAllInvestmentRounds } from '../../common/api/InvestmentRoundAPIHelper';
import { GetAllInvestmentTypes } from '../../common/api/InvestmentTypeAPIHelper';
import './investmentForm.css';
import "../../common/css/protagonistForm.css";
import { GetAllFunds } from '../../common/api/FundAPIHelper';
import { GetAllPortfolioCompanies } from '../../common/api/PortcoAPIHelper';
import { formatISO } from 'date-fns';



function InvestmentForm({ onSubmit, editData, onClear }) {
  const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();
  const [saveMessage, setSaveMessage] = useState(null);
  const [roundOptions, setRoundOptions] = useState([]);
  const [investmentTypeOptions, setInvestmentTypeOptions] = useState([]);
  const [fundOptions, setFundOptions] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);

  function resetForm() {
    reset({
        investmentId: '',
        fund: '',
        company: '',
        amount: '',
        round: '',
        investmentType: '',
        date: '',
    });
  }


  useEffect(() => {

    if (editData) {
      let formattedDate = formatISO(new Date(editData.investmentDate), { representation: 'date' });
      setValue('investmentId', editData.investmentId);
      setValue('fund', editData.fundId);
      setValue('company', editData.portcoId);
      setValue('amount', editData.investmentAmount);
      setValue('round', editData.investmentRoundId);
      setValue('investmentType', editData.investmentTypeId);
      setValue('date', formattedDate);
      setSaveMessage(null);
    } else {
      resetForm();
    }
 

    const fetchInvestmentRounds = async () => {
      const response = await GetAllInvestmentRounds();
      
      // Check if response and body exists
      if (response && response.body) {
        // Parse the body string to get the rounds array
        const rounds = JSON.parse(response.body);
        
        // Now rounds should be an array and can be used to set the state
        setRoundOptions(rounds);
      }
    };

    const fetchInvestmentTypes = async () => {
      const response = await GetAllInvestmentTypes();
      
      // Check if response and body exists
      if (response && response.body) {
        // Parse the body string to get the rounds array
        const types = JSON.parse(response.body);
        
        // Now rounds should be an array and can be used to set the state
        setInvestmentTypeOptions(types);
      }
    };

    const fetchFundOptions = async () => {
      const response = await GetAllFunds();
      
      // Check if response and body exists
      if (response && response.body) {
        // Parse the body string to get the fund array
        const funds = JSON.parse(response.body);
        
        // Now funds should be an array and can be used to set the state
        setFundOptions(funds);
      }
    };

    const fetchCompanyOptions = async () => {
      try {
          const response = await GetAllPortfolioCompanies();
          
          // Check if response exists
          if (response) {
              // Transform the data as per your needs...
              const transformedData = response.map(item => {
                  return {
                      portco_id: item.portco_id,
                      company_name: item.company_name,
                      company_legal_name: item.company_legal_name,
                      pitchbook_id: item.pitchbook_id,
                      website_url: item.website_url,
                      website_blurb: item.website_blurb,
                      show_on_public_website: item.show_on_public_website
                  };
              });
  
              // Now companies should be an array and can be used to set the state
              setCompanyOptions(transformedData);
          }
      } catch (error) {
          console.error(error);
      }
  };
  
  
    fetchInvestmentRounds();
    fetchInvestmentTypes();
    fetchFundOptions(); 
    fetchCompanyOptions();
  }, [editData, setValue, reset]);


  const handleClear = () => {
    resetForm(); // Clear form fields
    if (editData) {
      onClear(); // Call the onClear function to clear the editData
    }
  };

  const formSubmitHandler = async (data) => {
    try {
      const { investmentId, fund, company, amount, round, investmentType, date } = data;
      console.log("Calling Update Investment " + investmentId);
      const responsePromise = await UpdateInvestment(investmentId, company, fund, date, amount, round, investmentType);
      const response = await responsePromise;
      
      if (response && response.status === 200) {
        setSaveMessage('Successfully saved the investment.'); 
        resetForm();
        onSubmit();
      } else {
        setSaveMessage('There was a problem saving the investment. Please try again.'); 
      }
    } catch (error) {
      console.error('Error:', error);
      setSaveMessage('There was a problem saving the investment. Please try again.'); 
    }
    resetForm(); 
  }

  return (
    <form className="prot-admin-form" onSubmit={handleSubmit(formSubmitHandler)}>
      {editData ? (
        <div className="form-edit-message">Editing Investment Id : {editData.portcoId}</div>
      ) : (
        <div className="form-edit-message">(Create new Investment)</div>
      )}
      <input
        type="hidden"
        {...register("investmentId")}
      />
      <div className="form-group">
        <label htmlFor="fund">Fund*</label>
        <select {...register("fund", { required: true })}>
          <option value="">Select a fund</option>
          {fundOptions.map((fund) => (
            <option key={fund.internal_fund_id} value={fund.internal_fund_id}>
              {fund.fund_name}
            </option>
          ))}
        </select>
        {errors.fund && <span>This field is required</span>}
      </div>
      <div className="form-group">
        <label htmlFor="company">Portfolio Company*</label>
        <select {...register("company", { required: true })}>
          <option value="">Select a company</option>
          {companyOptions.map((company) => (
            <option key={company.portco_id} value={company.portco_id}>
              {company.company_name}
            </option>
          ))}
        </select>
        {errors.company && <span>This field is required</span>}
      </div>

      <div className="form-group">
        <label htmlFor="amount">Investment Amount*</label>
        <input
          type="number"
          {...register("amount", { required: true })}
          placeholder="$0.00"
        />
        {errors.amount && <span>This field is required</span>}
      </div>
      <div className="form-group">
        <label htmlFor="round">Investment Round*</label>
        <select {...register("round", { required: true })}>
          <option value="">Select a round</option>
          {roundOptions.map((round) => (
            <option key={round.investment_round_id} value={round.investment_round_id}>
              {round.investment_round_name}
            </option>
          ))}
        </select>
        {errors.round && <span>This field is required</span>}
      </div>
      <div className="form-group">
        <label htmlFor="investmentType">Investment Type*</label>
        <select {...register("investmentType", { required: true })}>
          <option value="">Select Investment Type</option>
          {investmentTypeOptions.map((investmentType) => (
            <option key={investmentType.investment_type_id} value={investmentType.investment_type_id}>
              {investmentType.investment_type_name}
            </option>
          ))}
        </select>
        {errors.investmentType && <span>This field is required</span>}
      </div>
      <div className="form-group">
        <label htmlFor="date">Investment Date*</label>
        <input
          type="date"
          {...register("date", { required: true })}
          placeholder="mm/dd/yyyy"
        />
        {errors.date && <span>This field is required</span>}
      </div>
      <div className="buttons">
        <button className="ra__protAdminform_button" type="submit">Save</button>
        <button className="ra__protAdminform_button" type="button" onClick={handleClear}>Clear</button>
      </div>
      {saveMessage && <div className="save-message">{saveMessage}</div>}
    </form>
  );
}

export default InvestmentForm;
